/**
 * Arranges items so the widest is in the middle, with progressively
 * narrower items alternating on the sides.
 * Example: For widths [100, 80, 60, 40, 20] sorted desc,
 * result order: [40, 60, 100, 80, 20] (indices: 3, 2, 0, 1, 4)
 */
export function arrangeMiddleOut<T>(items: Array<T>, getWidth: (item: T) => number): Array<T> {
  if (items.length <= 1) return items;

  // Sort by width descending
  const sorted = [...items].sort((a, b) => getWidth(b) - getWidth(a));

  const result: Array<T> = new Array(sorted.length);
  const middleIndex = Math.floor(sorted.length / 2);

  // Place items alternating from the middle outward
  let left = middleIndex;
  let right = middleIndex;

  for (let i = 0; i < sorted.length; i++) {
    if (i === 0) {
      // Widest goes in the middle
      result[middleIndex] = sorted[i];
    } else if (i % 2 === 1) {
      // Odd indices go to the right
      right++;
      result[right] = sorted[i];
    } else {
      // Even indices go to the left
      left--;
      result[left] = sorted[i];
    }
  }

  return result;
}
